import LeadsService from "@/api/services/leads";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  totalPages: null,
  totalCount: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isLive: () => (lead) => {
      return lead?.status === "live";
    },
    productRequired: () => (lead) => {
      return !lead?.productless;
    },
    isRenewal: () => (lead) => {
      return lead?.type === "renewal";
    },
    isWaitingForConfirmation: () => (lead) => {
      return lead?.status === "waiting_for_confirmation";
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.leads;
      state.totalPages = data.page?.totalPages || 0;
      state.totalCount = data.page?.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, params) {
      const response = await LeadsService.fetchIndex(params);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async update(_, { leadId, data }) {
      return await LeadsService.update(leadId, data);
    },
    async disable(_, { leadId }) {
      return await LeadsService.disable(leadId);
    },
  },
};
